import React, { useState } from "react";

import AccordionItem from "./AccordionItem";
import Coupons from "./Coupons";
import Bundles from "./Bundles";
import TaxCollection from "./TaxCollection";

import { Accordion } from "@mantine/core";

export default function Extras(props) {
  const [accordionState, setAccordionState] = useState({
    0: false,
    1: false,
    2: false
  });

  return (
    <Accordion>
      <Accordion.Item
        label={
          <AccordionItem
            accordionState={accordionState}
            index={0}
            label={"Coupons"}
            key={"coupons"}
            description={`Coupons allow you to offer custom discounts on space payments.`}
          />
        }
      >
        <Coupons />
      </Accordion.Item>

      <Accordion.Item
        label={
          <AccordionItem
            accordionState={accordionState}
            index={1}
            label={"Bundles"}
            key={"bundles"}
            description={`Bundles allow you to package access to multiple spaces with one purchase.  You can have them show up on your checkout page or add a bundle button from the block menu on any content page.`}
          />
        }
      >
        <Bundles />
      </Accordion.Item>

      <Accordion.Item
        label={
          <AccordionItem
            accordionState={accordionState}
            index={2}
            label={"Tax collection"}
            key={"tax_collection"}
            description={"Sutra can automatically process taxes on payments you collect if you have set up"}
          />
        }
      >
        <TaxCollection />
      </Accordion.Item>
    </Accordion>
  );
}
